import React from "react";
import { isAuthentic, getGradingNameFromGrade } from "../../utils/utils";

const LegacyLabel = ({
  labelLines = [],
  titleLine,
  serialNumber,
  grading,
  evaluation,
}) => {
  const authentic = isAuthentic(grading);
  const gradeOverall = grading.grade_overall;

  let isHalfVote = false;
  let gradeToDisplay = gradeOverall;
  if (gradeToDisplay?.toString().includes('.') && !authentic) {
    isHalfVote = true;
    gradeToDisplay = gradeToDisplay.toString().split('.')[0];
  }

  const resolvedEvaluation = evaluation
    || (gradeOverall != null ? getGradingNameFromGrade(gradeOverall.toString(), grading.is_10_perfect) : null);
  const caseFresh = Boolean(grading.is_case_fresh) && !authentic;
  const evaluationText = authentic
    ? 'AUTHENTIC'
    : (caseFresh ? 'CASE FRESH' : (resolvedEvaluation?.[1]?.toUpperCase() || ''));
  const hasGrade = gradeOverall != null;
  // L'esito puo esistere senza voto numerico: authentic e case fresh sono alternative al grade.
  const gradeLabel = authentic ? 'A' : (caseFresh ? 'CF' : gradeToDisplay);
  const showGrade = hasGrade || authentic || caseFresh;

  // Qualifier (es. ERROR / SIGNED): nascosto se none/vuoto, authentic o case fresh.
  const qualifierText = grading.qualifier
    && grading.qualifier.toLowerCase().trim() !== 'none'
    && !authentic
    && !grading.is_case_fresh
    ? grading.qualifier.toUpperCase()
    : null;

  // labelLines = [collector_number, game, expansion, version-rarity], titleLine = card name.
  // La label legacy mostra 4 righe: game / espansione / nome+numero / versione-rarita.
  const [collectorNumber, gameLine, expansionLine, versionRarityLine] = labelLines;
  const nameLine = [titleLine, collectorNumber].filter(Boolean).join(' ');
  const rows = [gameLine, expansionLine, nameLine, versionRarityLine];

  return (
    <>
      <img src="/images/label_classic_front.png" alt="" className="dco__label-image" />

      <div className="dco__label-text dco__label-text--legacy">
        {serialNumber && (
          <div className="dco__legacy-serial">{serialNumber}</div>
        )}

        <div className="dco__legacy-lines">
          {rows.map((row, i) => (
            row ? <div key={i} className="dco__legacy-line">{row}</div> : null
          ))}
        </div>

        {showGrade && (
          <div className="dco__legacy-grade-col">
            <div className="dco__legacy-evaluation">{evaluationText}</div>
            <div className="dco__legacy-grade">
              {gradeLabel}
              {isHalfVote && !authentic && !caseFresh && <span className="dco__legacy-grade-half">.5</span>}
            </div>
            {qualifierText && (
              <div className="dco__legacy-qualifier">{qualifierText}</div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default LegacyLabel;
